/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import { IconName, Header as VaiHeader, Heading, Button, Icon, ButtonType, Size } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { useTranslation } from 'react-i18next';
import LanguageController from '../../../../modules/LanguageController';
import './Header.scss';
import { isMobileOnly } from 'react-device-detect';

interface HeaderProps {
  title: string;
  unitOptions: string[];
  unitIndex: number;
  onChooseUnit: (ind: number) => void;
  toggleTheme: VoidFunction;
  onMobileMenuOpen: VoidFunction;
  onHelpOpen: VoidFunction;
  showPWAButton: boolean;
  onShowPWAPrompt: VoidFunction;
  activeMethod: number;
  theme: string;
  onMethodSelect: (method: number) => void;
  selectedChemical: number
  onChemicalChanged: (id: number) => void
}

const Link = (props: any) => <button {...props}>{props.children}</button>;

const Header = ({
  toggleTheme,
  title,
  unitOptions,
  unitIndex,
  onChooseUnit,
  onMobileMenuOpen,
  onHelpOpen,
  showPWAButton,
  onShowPWAPrompt,
  activeMethod,
  onMethodSelect,
  theme,
  selectedChemical,
  onChemicalChanged
}: HeaderProps) => {
  const { t } = useTranslation();

  return (
    <VaiHeader
      className={`header ${activeMethod > -1 ? 'header--method-selected' : ''} ${
        isMobileOnly ? 'header--mobile' : 'header--desktop'
      } ${theme}`}
      logoVisible={!isMobileOnly}
      title=""
    >
      {isMobileOnly && (
        <>
          <button className={`back-button ${selectedChemical > -1 ? 'is-active' : ''}`} onClick={() => onChemicalChanged(-1)}>
            <Icon name={VaiIcon.ChevronLeft} size={Size.XL} />
          </button>

          <Icon name={VaiIcon.VaisalaLogoLarge} size={Size.S} />
        </>
      )}

      {!isMobileOnly && (
        <>
          <div>
            <Heading className="custom-header" level={1}>
              {t(title)}
            </Heading>
          </div>

          {showPWAButton && (
            <Button buttonType={ButtonType.Secondary} buttonSize={Size.M} startIcon={<Icon name={VaiIcon.Download} />} onClick={onShowPWAPrompt}>
              {t('ui.install')}
            </Button>
          )}

          {/* <VaiHeader.Item iconName={IconName.Help} onClick={onHelpOpen} title={t('ui.help')} /> */}
          {/* <VaiHeader.Menu iconName={IconName.FilterSwitches} title={t('ui.units')}>
            {unitOptions.map((option, i) => {
              return (
                <VaiHeader.MenuItem key={i} component={Link} iconName={i === unitIndex ? IconName.Check : undefined} onClick={() => onChooseUnit(i)}>
                  {t(option)}
                </VaiHeader.MenuItem>
              );
            })}
          </VaiHeader.Menu> */}
          <VaiHeader.Item iconName={IconName.Contrast} onClick={toggleTheme} title={t('ui.theme')} />
          <VaiHeader.Menu
            iconName={isMobileOnly ? undefined : IconName.Language}
            title={isMobileOnly ? LanguageController.currentLanguageNameShort : LanguageController.currentLanguageName}
          >
            {LanguageController.languages.map((lng, i) => (
              <VaiHeader.MenuItem
                key={i}
                component={Link}
                iconName={LanguageController.isCurrentLanguage(lng) ? IconName.Check : undefined}
                onClick={() => LanguageController.changeLanguage(lng)}
              >
                {LanguageController.languageName(lng)}
              </VaiHeader.MenuItem>
            ))}
          </VaiHeader.Menu>
        </>
      )}

      {isMobileOnly && <VaiHeader.Item iconName={IconName.MobileMenu} onClick={onMobileMenuOpen} />}
    </VaiHeader>
  );
};
export default Header;
